/**
 * Fime – Credentials-Accreditations: category tab filter.
 * Client-side only (no page reload) — clicking a tab shows only the
 * cards matching that category, hides the rest.
 */

const credentialsTabs = document.querySelectorAll('.credentials-tab');
const credentialsCards = document.querySelectorAll('[data-category]');

credentialsTabs.forEach(function (tab) {
	tab.addEventListener('click', function () {
		const category = tab.dataset.categoryTab;

		credentialsTabs.forEach(function (t) {
			t.classList.remove('is-active');
		});
		tab.classList.add('is-active');

		credentialsCards.forEach(function (card) {
			card.hidden = card.dataset.category !== category;
		});
	});
});
